import React from "react";

const ABOUT_IMG =
    "https://images.unsplash.com/photo-1546412414-e1885259563a?crop=entropy&cs=srgb&fm=jpg&w=1400";

export default function About() {
    return (
        <section id="about" className="section relative" data-testid="about-section">
            <div className="container-x grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20 items-center">
                {/* Image side */}
                <div className="lg:col-span-5 order-2 lg:order-1">
                    <div className="relative">
                        <div className="absolute -top-4 -left-4 w-full h-full border border-[#C8A064]/40" />
                        <img
                            src={ABOUT_IMG}
                            alt="Vantage Markets Dubai office"
                            className="relative w-full h-[560px] object-cover"
                        />
                        <div className="absolute bottom-6 left-6 right-6 card-glass p-6">
                            <div className="overline mb-2">Vantage Markets · Dubai</div>
                            <div className="font-serif-display text-2xl text-[#F3F4F6] leading-snug">
                                A Quiet Engine Behind Vantage's Global Growth.
                            </div>
                        </div>
                    </div>
                </div>

                {/* Text side */}
                <div className="lg:col-span-7 order-1 lg:order-2">
                    <div className="flex items-center gap-3 mb-6">
                        <span className="h-px w-10 bg-[#C8A064]" />
                        <span className="overline">About NexaReach</span>
                    </div>

                    <h2 className="font-serif-display text-3xl sm:text-4xl lg:text-5xl text-[#F3F4F6] leading-tight">
                        We don't push products. We{" "}
                        <em className="text-[#C8A064] not-italic">connect the right traders</em> to
                        the right brokerage.
                    </h2>

                    <p className="mt-8 text-[#94A3B8] text-base leading-relaxed">
                        NexaReach LLC is an outreach and client-development firm operating in
                        exclusive partnership with{" "}
                        <span className="text-[#F3F4F6]">Vantage Markets</span> — a globally
                        regulated multi-asset broker serving over a million traders. Our team is
                        built around one principle: every call must add value, whether or not the
                        client opens an account.
                    </p>

                    <p className="mt-4 text-[#94A3B8] text-base leading-relaxed">
                        We study spreads, leverage rules, platform mechanics, and regulatory
                        nuances the way analysts study markets — so when we speak with a prospect,
                        we speak with substance. That's how trust is built. And that's how
                        long-term clients are made.
                    </p>

                    <div className="mt-10 grid grid-cols-2 gap-6">
                        <Pillar title="Transparency" copy="No hidden incentives. We disclose what we do and why." />
                        <Pillar title="Mastery" copy="Continuous training on Vantage's full product suite." />
                        <Pillar title="Respect" copy="Every prospect is treated as a future partner." />
                        <Pillar title="Results" copy="Measured by retention, not just first deposits." />
                    </div>
                </div>
            </div>
        </section>
    );
}

const Pillar = ({ title, copy }) => (
    <div className="border-l border-[#C8A064]/30 pl-5">
        <div className="font-serif-display text-xl text-[#C8A064] mb-1">{title}</div>
        <p className="text-sm text-[#94A3B8] leading-relaxed">{copy}</p>
    </div>
);
